module.exports = __webpack_public_path__ + "static/media/5D.d5f442e5.svg";